var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.arrayListLength > 0)?_c('span',[(_vm.direction === 'asc')?_c('font-awesome-icon',{staticClass:"sort-arrow-up",attrs:{"icon":"arrow-up"}}):_vm._e(),(_vm.direction === 'desc')?_c('font-awesome-icon',{staticClass:"sort-arrow-down",attrs:{"icon":"arrow-down"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }